import Immutable from 'seamless-immutable';
import _ from 'lodash';
import { enums } from 'console-kit';
import RefData from 'ref-data';

import WinnerCollection from './winner-collection.js';

/**
 * Draw
 * @typedef {object} Draw
 * @property {number} id - the draw id
 * @property {number} campaignObjectId - the campaign id the draw relates to
 * @property {object} config - the draw config
 * @property {string} createdBy - the user that created the draw
 * @property {string} drawDate - the date the user that created the draw
 * @property {string} lastUpdated - the date the draw was last updated
 * @property {string} modifiedBy - the user that last updated the draw
 * @property {string} name - the name of the draw - not used?
 * @property {array} places - the winners in the draw
 * @property {string} status - the status of the draw
 */

function create(draw = _defaultDraw) {
  const result = _.clone(draw);
  result.places = WinnerCollection.deserialize(draw.places);
  result.status = RefData.Model.hydrate(draw.status);
  return Immutable(result, { prototype: model });
}

function deserialize(draw) {
  const result = _.pick(draw, _keys);
  return create(result);
}

function serialize(draw) {
  const result = _.pick(draw, _keys);
  result.places = WinnerCollection.serialize(draw.places);
  result.status = draw.status.id;
  return create(result);
}

const model = {
  get isManualDraw() {
    return this.status.id === RefData.Enum.STATUS.DRAW.MANUAL;
  },
};

const _keys = [
  'campaignObjectId',
  'config',
  'createdBy',
  'dateCreated',
  'drawDate',
  'id',
  'lastUpdated',
  'modifiedBy',
  'name',
  'places',
  'status',
];

const _defaultDraw = {};

export default {
  create,
  deserialize,
  serialize,
};
